import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import Reveal, { Caption } from "@/components/Reveal";

export default function TermsPage() {
  const { t } = useLang();
  const sections = t("terms.sections");

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-8 py-16 sm:py-24" data-testid="terms-page">
      <Reveal>
        <Caption>{t("terms.caption")}</Caption>
        <h1 className="font-serif text-4xl sm:text-5xl leading-tight mt-4 text-ink">{t("terms.title")}</h1>
        <p className="text-xs font-mono uppercase tracking-[0.15em] text-ink/40 mt-3">{t("terms.updated")}</p>
        <p className="text-ink/65 leading-relaxed mt-6">{t("terms.intro")}</p>
      </Reveal>

      <div className="mt-10 space-y-8">
        {(Array.isArray(sections) ? sections : []).map((s, i) => (
          <Reveal key={i} delay={Math.min(i * 0.04, 0.3)}>
            <div data-testid={`terms-section-${i}`}>
              <h2 className="font-serif text-xl sm:text-2xl text-ink mb-2">{s.h}</h2>
              <p className="text-sm sm:text-base text-ink/65 leading-relaxed">{s.b}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal className="mt-12">
        <Link
          to="/"
          data-testid="terms-back-btn"
          className="inline-flex items-center gap-2 text-sm font-semibold text-terracotta hover:text-gold transition-colors"
        >
          <ArrowLeft size={15} /> Villa Paraiso
        </Link>
      </Reveal>
    </div>
  );
}
